import messageConstants from '../constants/message';

const messageActions = {};

const messageClear = (errorMessage) => ({
  type: messageConstants.CLEAR_MESSAGES
})

messageActions.clearMessages = (isLoading) => {
  return (dispatch) => {
    dispatch(messageClear());
  }
}

const errorMessageSet = (errorMessage) => ({
  type: messageConstants.SET_ERROR_MESSAGE,
  errorMessage
})

messageActions.setErrorMessage = (errorMessage) => {
  return (dispatch) => {
    dispatch(messageClear());
    dispatch(errorMessageSet(errorMessage));
  }
}

const successMessageSet = (successMessage) => ({
  type: messageConstants.SET_SUCCESS_MESSAGE,
  successMessage
})

messageActions.setSuccessMessage = (successMessage) => {
  return (dispatch) => {
    dispatch(messageClear());
    dispatch(successMessageSet(successMessage));
  }
}

export default messageActions;



/** WEBPACK FOOTER **
 ** ./src/actions/message.js
 **/